/* global axios */
import ApiClient from './ApiClient';

class InboxHealthAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getHealthStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/health`);
  }

  registerWebhook(inboxId) {
    return axios.post(`${this.url}/${inboxId}/register_webhook`);
  }

  // Connection of a self-hosted WhatsApp session. Reconnect asks the gateway for a QR against the inbox
  // that already exists, which is what makes re-pairing possible without deleting it — a delete would take
  // the conversations and messages with it.
  getConnection(inboxId) {
    return axios.get(`${this.url}/${inboxId}/connection`);
  }

  restartConnection(inboxId) {
    return axios.post(`${this.url}/${inboxId}/restart_connection`);
  }

  reconnectConnection(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reconnect_connection`);
  }

  disconnectConnection(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/disconnect_connection`);
  }

  retryFailedMessages(inboxId) {
    return axios.post(`${this.url}/${inboxId}/retry_failed_messages`);
  }

  // Takes the failed messages out of the Connection tab without sending them. They stay in their threads,
  // still marked as not delivered.
  dismissFailedMessages(inboxId) {
    return axios.post(`${this.url}/${inboxId}/dismiss_failed_messages`);
  }
}

export default new InboxHealthAPI();
